import { render } from "./ResultsInternal.vue?vue&type=template&id=19098aac&scoped=true"
import script from "./ResultsInternal.vue?vue&type=script&lang=js"
export * from "./ResultsInternal.vue?vue&type=script&lang=js"

import "./ResultsInternal.vue?vue&type=style&index=0&id=19098aac&scoped=true&lang=css"

import exportComponent from "/var/www/matchmaker/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19098aac"]])

export default __exports__